import { render } from "./App.vue?vue&type=template&id=85c0f8ea"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=85c0f8ea&lang=less"

import exportComponent from "/var/jenkins_home/workspace/生产环境/M平台/前端/servicepartner.matchupexpo.com - 外呼合作方端/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__